import "core-js/modules/es.array.concat.js";
import React, { Fragment } from 'react';
import { Datalayer } from '@finect/front-gtm';
import { Follow } from '../Follow';
import { CardInner } from '../commons/CardInner';
import { ProductInfo } from './ProductInfo';
import ProfileInfo from './ProfileInfo';
import { TagInfo } from './TagInfo';
import { Actions } from './partials';
import { Card } from './Card';
export var EntityCardContent = function EntityCardContent(_ref) {
  var type = _ref.type,
    entity = _ref.entity,
    follow = _ref.follow,
    following = _ref.following,
    position = _ref.position,
    arrowPosition = _ref.arrowPosition;
  var cardInfo;
  if (type === 'profile') {
    cardInfo = React.createElement(ProfileInfo, {
      entity: entity
    });
  }
  if (type === 'tag') {
    cardInfo = React.createElement(TagInfo, {
      entity: entity
    });
  }
  if (type === 'product') {
    cardInfo = React.createElement(ProductInfo, {
      entity: entity
    });
  }
  if (!cardInfo) return null;
  return React.createElement(Fragment, null, React.createElement(Datalayer, {
    id: "FiEvent",
    type: "fiEvent",
    params: {
      category: 'Interaction',
      action: entity.alias || 'unknown',
      label: 'entityCard-show'
    }
  }), React.createElement(Card, {
    posX: position.x,
    posY: position.y
  }, React.createElement(CardInner, {
    posX: position.x,
    posY: position.y,
    arrowPos: arrowPosition,
    type: "entity"
  }, cardInfo, React.createElement(Actions, null, type === 'profile' && React.createElement("a", {
    href: "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com', "/mensajes/nuevo?members=").concat(entity.id)
  }, "Enviar mensaje"), React.createElement(Follow, {
    following: following,
    follow: follow,
    small: true
  }, "Seguir")))));
};